export default __webpack_public_path__ + "static/media/macbook-video.73837648.png";